"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var GroupTitle = _styledComponents["default"].h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: #c8c8c8;\n    font-size: 0.8rem;\n    border-bottom: 1px solid #f0f0f0;\n    padding-bottom: 0.5rem;\n    margin-bottom: 0.5rem;\n    text-transform: uppercase;\n    font-weight: 500;\n"])));

var Group = function Group(_ref) {
  var id = _ref.id,
      name = _ref.name,
      predicate = _ref.predicate,
      children = _ref.children;
  return predicate() ? /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: "card card--shadow mb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react["default"].createElement(GroupTitle, null, name), children)) : null;
};

Group.displayName = 'Group';
Group.propTypes = {
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  predicate: _propTypes["default"].func,
  children: _propTypes["default"].node
};
Group.defaultProps = {
  predicate: function predicate() {
    return true;
  }
};
var _default = Group;
exports["default"] = _default;